import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function Header() {
  const isCalculatorPage = location.pathname === '/';

  return (
    <header className="backdrop-blur-md bg-white/30 border-b border-white/20">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex items-center gap-4">
              <div className="h-12 w-32 relative flex-shrink-0">
                <img 
                  src="https://www.syngenta.com.pe/sites/g/files/kgtney1166/files/styles/brand_logo/public/media/image/2024/01/31/baloric-thumbnail.png?itok=EXGXM7EV" 
                  alt="Baloric Logo" 
                  className="h-full w-full object-contain"
                />
              </div>
              <div className="h-12 w-32 relative flex-shrink-0">
                <img 
                  src="https://i.postimg.cc/15M8VzGL/Altessia-Logo-CMYK-Final.png" 
                  alt="Altessia Logo" 
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
            <div className="text-center md:text-left">
              <h1 className="text-xl font-semibold text-gray-800">Rice Crop Weed Control Calculator</h1>
              <p className="text-sm text-gray-600">Optimize your weed control costs</p>
            </div>
          </div>
          
          {!isCalculatorPage && (
            <Link
              to="/"
              className="inline-flex items-center px-6 py-2.5 bg-gradient-brand text-white rounded-full shadow-lg shadow-brand-green/20 hover:shadow-brand-green/30 hover:scale-[1.02] transition-all duration-200 font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              New Calculation
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;